import * as React from 'react';
import { ModalComponentProps } from 'Components/General/Modal/ModalContext';
import { Form, Input, Button } from 'antd';
import { I18N_NS } from 'Config/i18n';
import { useTranslation } from 'react-i18next';
import { ViewUIFilters } from '../Pages/View';

export interface SaveViewFilterProps extends ModalComponentProps {
  filterData: ViewUIFilters;
  onSubmit: (data: API_ViewFilter) => Promise<void>;
}

export const SaveViewFilter = ({ filterData, onSubmit, hideModal, }: SaveViewFilterProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const [loading, setLoading] = React.useState(false);

  const handleFinish = async ({ name }: { name: string }) => {
    try {
      setLoading(true);
      const { created, ...metadata } = filterData;
      const formData: API_ViewFilter = {
        name,
        created,
        metadata
      };
      await onSubmit(formData);
      hideModal();
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onFinish={handleFinish}>
      <Form.Item label={t('Name')} name="name">
        <Input autoFocus={true} />
      </Form.Item>
      <div className="text-right">
        <Button type="primary" htmlType="submit" loading={loading}>{t('Save')}</Button>
      </div>
    </Form>
  );
};